// utils/incidentUtils.ts

const severityColors: Record<string, string> = {
    critical: 'bg-red-100 text-red-800 border-red-200',
    high: 'bg-orange-100 text-orange-800 border-orange-200',
    medium: 'bg-yellow-100 text-yellow-800 border-yellow-200',
    low: 'bg-green-100 text-green-800 border-green-200',
};

const defaultSeverityColor = 'bg-gray-100 text-gray-800 border-gray-200';

export const getSeverityColor = (severity: string) => {
    return severityColors[severity] || defaultSeverityColor;
};

export const getConfidenceColor = (score: number) => {
    if (score >= 0.8) return 'text-green-600';
    if (score >= 0.6) return 'text-yellow-600';
    return 'text-red-600';
};

export const getBadgeColor = (isFromHistory: boolean) => {
    return isFromHistory
        ? 'bg-purple-100 text-purple-800'
        : 'bg-green-100 text-green-800';
};

export const getSourceLabel = (isFromHistory: boolean) => {
    return isFromHistory ? 'Historical Data' : 'AI Generated';
};

export const getStatusColor = (status: string) => {
    switch (status) {
        case 'open': return 'bg-red-100 text-red-800';
        case 'in_progress': return 'bg-yellow-100 text-yellow-800';
        case 'resolved': return 'bg-green-100 text-green-800';
        case 'closed': return 'bg-gray-100 text-gray-800';
        default: return 'bg-gray-100 text-gray-800';
    }
};
